import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M15 11H9V7H7v10h2v-4h6v4h2V7h-2v4z"
}), 'HMobiledataOutlined');